import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterManagementRoute: InvariantJiraRoute = {
	exact: true,
	name: 'helpcenter-management',
	path: '/jira/helpcenter-management',
};
